var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-uppercase",class:{ brand: !_vm.small, 'brand-sm': _vm.small, dark: _vm.dark, light: !_vm.dark },attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.brandName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }